import { render } from "./co2Controller.vue?vue&type=template&id=2e1ce287&scoped=true"
import script from "./co2Controller.vue?vue&type=script&lang=js"
export * from "./co2Controller.vue?vue&type=script&lang=js"

import "./co2Controller.vue?vue&type=style&index=0&id=2e1ce287&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e1ce287"]])

export default __exports__